/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import UserDashBoardSideNavigation from '../userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from '../userDashBoard.components/UserDashBoardTopNavigation';
import fixtipInvestment from '../../../actions/investment.actions/getFixTip.action';
import MyInvestmentPlans from './MyInvestmentPlans';
import InvestStartPage from './InvestStartPage';
import fetchMtLip from '../../../actions/investment.actions/mtLipActions/getMtlip.action';
import getUserMutualFund from '../../../actions/mutualFunds.actions/getUserMutualFund';

/**
 * @class InvestPageOption
 */
class InvestPageOption extends Component {
  componentWillMount = () => {
    const {
      FixtipInvestment,
      FetchMtLip,
    } = this.props;
    FixtipInvestment();
    FetchMtLip();
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      userFixTipInvestment,
      userMtLipInvestment,
      userMutualFund,
    } = this.props;
    const { mtLipInvest } = userMtLipInvestment;
    const { fixTipInvest } = userFixTipInvestment;

    const mainInvestmentObject = mtLipInvest.concat(fixTipInvest);

    return (
      <>
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {
            mainInvestmentObject.length === 0 ? (
              <InvestStartPage />
            ) : (
              <MyInvestmentPlans
                fixTipInvestObj={fixTipInvest}
                mtLipInvestObj={mtLipInvest}
                userMutualFundObj={userMutualFund.mutualFunds}
              />
            )
          }
        </div>
      </>
    );
  }
}

InvestPageOption.propTypes = {
  userFixTipInvestment: PropTypes.array,
  FixtipInvestment: PropTypes.func,
  FetchMtLip: PropTypes.func,
  userMtLipInvestment: PropTypes.array,
  userMutualFund: PropTypes.any,
};

const mapStateToProps = state => ({
  userFixTipInvestment: state.fetchFixTipInvestment,
  userMtLipInvestment: state.fetchMtLipInvestment,
  userMutualFund: state.userMutualFund,
});

export default connect(mapStateToProps, {
  FixtipInvestment: fixtipInvestment,
  FetchMtLip: fetchMtLip,
  GetUserMutualFund: getUserMutualFund,
})(InvestPageOption);
